// extracted by css-extract-rspack-plugin
export default {"logo":"zA5Sjd","return":"qBVdhy","hideLogo":"tv_2uh"};